import { getEnv } from "src/utils/EnvironmentTools";
import { ImageInfo, SignedUrlResponse, } from "src/utils/upload-image/model/upload-image.model";
import { createGetSignedUrlBody, getUploadHeaders, UploadImageErrorTypes, } from "src/utils/upload-image/UploadImageTools";
import { FetchOptions } from "../api.models";

class AmandaApi {
  async signedURL<T>(imageInfo: ImageInfo): Promise<SignedUrlResponse> {
    const body = await createGetSignedUrlBody(imageInfo);
  
    const options: FetchOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    };
  
    const url = getEnv().amandaBaseUrl + "/v2/signedUrl";
  
    try {
      const response = await fetch(url, options);
      return await response.json();
    } catch (error) {
      return await Promise.reject(new Error(UploadImageErrorTypes.Signing));
    }
  }
  
  async uploadSignedURL<T>( imageInfo: ImageInfo, signedUrlResponse: SignedUrlResponse, ): Promise<{ assetId: string }> {
    const { url, assetId } = signedUrlResponse;
    const { file } = imageInfo;
  
    const options: FetchOptions = {
      method: "PUT",
      headers: getUploadHeaders(imageInfo, signedUrlResponse),
      body: file,
    };
  
    try {
      const response = await fetch(url, options);
        return { assetId };
    } catch (error) {
        return await Promise.reject(new Error(UploadImageErrorTypes.Uploading));
    }
  }
}

export default AmandaApi;